var moduleMap = {
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("src_api_RpcAPI_RpcAPI_ts-src_service-setup_diContainer_ts"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.ts")))));
	},
	"./cart-sidebar-cart-offers": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/cart-sidebar-cart-offers/drupal.ts")))));
	},
	"./cart-sidebar-offers-tab": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/cart-sidebar-offers-tab/drupal.ts")))));
	},
	"./cart-sidebar-offer-code-module": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/offer-code-module/drupal.ts")))));
	},
	"./samplesComponent": () => {
		return Promise.resolve().then(() => (() => ((__webpack_require__("./src/exported/samples-component/drupal.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});